<template>
    <div class="enps-rating-donut">
        <div class="enps-rating-donut__chart" v-if="hasRatings">
            <Doughnut :chart-data="chartData" :chart-options="chartOptions" :styles="chartStyles"></Doughnut>
        </div>
        <div class="enps-rating-donut__chart enps-rating-donut__chart_empty" v-else>Нет оценок за период</div>
        <div class="enps-rating-donut__average" v-if="showAverage">
            {{ averageRating ?? '—' }}
            <span class="enps-rating-donut__average-label">средняя оценка</span>
        </div>
    </div>
</template>
<script>
import { Doughnut } from 'vue-chartjs/legacy';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

const RATING_COLORS = {
    5: '#00a55a',
    4: '#8bc34a',
    3: '#ffc107',
    2: '#ff9800',
    1: '#f44336',
};

// FR-010 блок 2: донат — сегменты по значению оценки (5..1), среднее число текстом рядом
// (оверлей поверх canvas обошёлся бы плагином chart.js ради одного числа — не оправдано).
@Component({
    components: {
        Doughnut,
    },
})
class EnpsRatingDonut extends Vue {
    @Prop({ type: Object, default: () => ({ 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 }) })
    ratingCounts;
    @Prop({ type: Number, default: null })
    averageRating;
    // false — когда среднее уже показано рядом (шапка карточки исполнителя): дублировать одно
    // число в двух сантиметрах друг от друга незачем.
    @Prop({ type: Boolean, default: true })
    showAverage;

    chartStyles = {
        height: '100%',
        width: '100%',
        position: 'relative',
    };

    get hasRatings() {
        return Object.values(this.ratingCounts).some((count) => count > 0);
    }

    get chartData() {
        const values = [5, 4, 3, 2, 1];

        return {
            labels: values.map((value) => `${value}`),
            datasets: [
                {
                    data: values.map((value) => this.ratingCounts[value] ?? 0),
                    backgroundColor: values.map((value) => RATING_COLORS[value]),
                },
            ],
        };
    }

    get chartOptions() {
        return {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: { position: 'right' },
            },
        };
    }
}

export default EnpsRatingDonut;
</script>
<style lang="scss">
.enps-rating-donut {
    display: flex;
    align-items: center;

    &__chart {
        width: 160px;
        height: 160px;
        flex-shrink: 0;

        &_empty {
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            color: #a0a0a0;
            font-size: 0.85rem;
        }
    }

    &__average {
        margin-left: 15px;
        font-size: 1.5rem;
        font-weight: 600;
        white-space: nowrap;
    }

    &__average-label {
        display: block;
        font-size: 0.75rem;
        font-weight: 400;
        color: #767676;
    }
}
</style>
